module.exports = __webpack_public_path__ + "static/goals_exploring_art-285ef945b7893bd359c545fe57f1d70c.png";